import React from "react";
import {
    TextField as BaseTextField,
    Input,
    Label,
    Text,
    TextArea,
    TextFieldProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { CommonFieldProps, FieldError } from "./utils";

import styles from "./inputs.module.scss";

export function TextField({
    label,
    description,
    errorMessage,
    className,
    multiline = false,
    onChange,
    ...props
}: CommonFieldProps &
    Omit<TextFieldProps, "className"> & {
        multiline?: boolean;
    }) {
    return (
        <BaseTextField
            {...props}
            className={concatClassNames([className, styles.textField])}
        >
            <Label>{label}</Label>
            <div>
                {multiline ? (
                    <TextArea className={styles.input} />
                ) : (
                    <Input className={styles.input} />
                )}
            </div>
            {description && <Text slot="description">{description}</Text>}
            <FieldError>{errorMessage}</FieldError>
        </BaseTextField>
    );
}
